<template>
  <div id="games" class="games main-component-container  bottom-corner-background-img">
      <v-card-title class="component-title">
          <img alt="ProjectTitle" v-bind:src="require('@/assets/Project2.png')" class="component-title-image">
      </v-card-title>
      <div class="component-content">
        <div class="row">
          <div class="about-text">
                <p v-for="(text, index) in $i18n.messages[$i18n.locale].games.content" :key="index">{{ text }}</p>
          </div>
          <div class = "row flex-item-space-between">
          <div ><img alt="Ilustration" v-bind:src="require('@/assets/Luna.png')" class="content-image"></div>
        <!--  <div>
            <img alt="Ilustration" v-bind:src="require('@/assets/Vero.png')" class="image content-image">
          </div>-->
          </div>
        </div>
      </div>

  </div>
    <!-- Carrusel de imagenes -->
    <!-- <h3>{{ $t('games.current.images_title') }}</h3>
    <v-carousel
        v-model="currentImage"
        height="auto"
        :show-arrows="false"
    >
        <v-carousel-item v-for="(image, index) in images" :key="index">
            <v-img
                :max-height="600"
                :aspect-ratio="16/9"
                :src="require(`@/assets/${image}`)"
            ></v-img>
        </v-carousel-item>
    </v-carousel> -->
</template>

<script>
//import Updates from './Updates'

export default {
    name:'Games',
    components: {
        //Updates
    }
}
</script>

<style scoped>
.no-padding {
		padding-top: 0 !important;
	}
.content-banner{
  display: flex;
  justify-content: center;
  width: 100%;
  height: 500px;
}
.component-title-image{
  -padding-top: 2rem;
  height: auto;
  width: 1000px;
}
.main{
    padding-top: 0 !important;
}
.component-title-banner{

}
.component-content{

}
.bottom-corner-background-img{
  background-image: url('~@/assets/Asta.png');
}

.games {

}
.v-application a {
  color: red !important;
}

@media only screen and (max-width: 800px) {

}
@media only screen and (max-width: 750px) {

}
@media (max-width: 480px) {

}
@media only screen and (max-width: 370) {

}
</style>
